import { Link } from "react-router-dom";
import { fechaLarga, tiempoDeLectura } from "../utils/fecha";
import { prepararCuerpo } from "../utils/texto";

// Pieza de artículo con la jerarquía de la prensa económica: antetítulo con la
// sección, titular centrado, firma, y la imagen con su pie antes del cuerpo.
const FullNews = ({ id, title, image, text, subtitle, categoria, fecha, minutos: minutosIndicados }) => {
  // Si la redacción fijó los minutos en el panel, mandan sobre el cálculo.
  const minutos = minutosIndicados || tiempoDeLectura(text);
  const url = typeof window !== 'undefined' ? window.location.href : '';

  const compartir = [
    {
      nombre: 'WhatsApp',
      href: `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`,
      icono: 'M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.9-4.45 9.9-9.91C21.95 6.45 17.5 2 12.04 2Zm5.8 14.02c-.25.69-1.44 1.32-1.99 1.36-.53.05-1.02.24-3.44-.72-2.9-1.14-4.74-4.1-4.88-4.29-.14-.19-1.16-1.55-1.16-2.95 0-1.4.73-2.09.99-2.37.26-.29.57-.36.76-.36h.54c.18 0 .42-.07.65.5.25.6.84 2.08.91 2.23.07.15.12.32.02.51-.09.19-.14.31-.28.48l-.42.48c-.14.14-.28.29-.12.57.16.28.71 1.17 1.53 1.9 1.05.94 1.94 1.23 2.21 1.37.28.14.44.12.6-.07.17-.19.7-.81.88-1.09.19-.29.37-.24.63-.14.25.09 1.6.75 1.87.89.28.14.46.21.53.33.07.11.07.66-.18 1.35Z',
    },
    {
      nombre: 'LinkedIn',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
      icono: 'M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05a3.74 3.74 0 0 1 3.37-1.85c3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13ZM7.12 20.45H3.55V9h3.57v11.45ZM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0Z',
    },
    {
      nombre: 'Facebook',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      icono: 'M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.68.24 2.68.24v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.25h3.33l-.53 3.49h-2.8V24C19.61 23.1 24 18.1 24 12.07Z',
    },
  ];

  return (
    <div className="news-section" style={{ backgroundColor: 'transparent' }}>
      <div className="content">
        {categoria && (
          <p className="ed-kicker" style={{ textAlign: 'center', marginBottom: '0.75rem' }}>
            <Link to="/">Portada</Link>
            {' / '}
            <Link to={`/categorias/${categoria.id}`}>{categoria.name}</Link>
          </p>
        )}

        <h1 className="title">{title}</h1>

        <p className="subtitle">
          <span>{subtitle}</span>
          {fecha ? ` | ${fechaLarga(fecha)}` : ''}
          {minutos ? ` | ${minutos} min de lectura` : ''}
        </p>

        <figure style={{ margin: 0 }}>
          <img
            src={image}
            alt={title}
            className={`image ${
              title?.toLowerCase().includes('central 105')
                ? 'imagen-central105'
                : ''
            }`}
          />
        </figure>

        <div dangerouslySetInnerHTML={{ __html: prepararCuerpo(text) }} className="text"></div>

        <div className="ed-compartir">
          <span className="ed-compartir__etiqueta">Compartir</span>
          {compartir.map(({ nombre, href, icono }) => (
            <a
              key={nombre}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="ed-compartir__boton"
              aria-label={`Compartir en ${nombre}`}
              title={`Compartir en ${nombre}`}
            >
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d={icono} />
              </svg>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FullNews;
